import {
  RepeatingTask,
  TaskFilterOptions,
  TaskType,
  WeekDays,
} from '@griply/types';

import { processScheduleTasks } from './process-schedule-tasks';

export type FilterRepeatingTasksOptions = {
  repeatingTasks: RepeatingTask[];
  filters: TaskFilterOptions[];
  weekStartsOn: WeekDays;
  today: Date;
};

export const filterRepeatingTasks = ({
  repeatingTasks,
  filters,
  weekStartsOn,
  today,
}: FilterRepeatingTasksOptions): RepeatingTask[] => {
  if (!repeatingTasks.length || !filters.length) {
    return repeatingTasks;
  }

  const hasDeadlineDeadlineFilters = filters.every(
    (f) =>
      f.deadlineDeadlineStartDate ||
      f.deadlineDeadlineEndDate ||
      f.hasDeadlineDeadline,
  );

  if (hasDeadlineDeadlineFilters) {
    return [];
  }

  // Check if ALL filter sets exclude repeating-tasks. If even one allows repeating-tasks, we proceed.
  const allowsRepeating = filters.some(
    (f) => !f.types?.length || f.types.includes(TaskType.Repeating),
  );

  if (!allowsRepeating) {
    return [];
  }

  return processScheduleTasks(repeatingTasks, filters, {
    weekStartsOn,
    today,
  }) as RepeatingTask[];
};
